function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireac40"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireac40"] = parcelRequire;
}
parcelRequire.register("eL13W", function(module, exports) {

$parcel$export(module.exports, "getLocalStorage", () => $2a0a9d2c002157bd$export$d3720feff416e85b);
$parcel$export(module.exports, "setLocalStorage", () => $2a0a9d2c002157bd$export$1f73f60bdb811cb1);
$parcel$export(module.exports, "generateBreadcrumb", () => $2a0a9d2c002157bd$export$7f4d634b10993eb6);
$parcel$export(module.exports, "getParam", () => $2a0a9d2c002157bd$export$ecf541e09a511845);
$parcel$export(module.exports, "addMovieToStorage", () => $2a0a9d2c002157bd$export$73bcfb39fabe8205);
$parcel$export(module.exports, "addCommentToStorage", () => $2a0a9d2c002157bd$export$b61b48db6d2fd5e7);
$parcel$export(module.exports, "createScrollBtn", () => $2a0a9d2c002157bd$export$538bbf850262f928);
// retrieve data from localstorage
function $2a0a9d2c002157bd$export$d3720feff416e85b(key) {
    return JSON.parse(localStorage.getItem(key));
}
function $2a0a9d2c002157bd$export$1f73f60bdb811cb1(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}
function $2a0a9d2c002157bd$export$7f4d634b10993eb6(param = "", mainEl = document.querySelector("main")) {
    const breadcrumbNav = document.createElement("div");
    breadcrumbNav.classList.add("breadcrumb-navigation");
    const breadcrumbList = document.createElement("ul");
    breadcrumbList.classList.add("breadcrumb-list");
    // create the home link and add it to the breadcrumb list
    const homeLink = $2a0a9d2c002157bd$var$createBreadcrumbLink("Home", "/index.html");
    breadcrumbList.appendChild(homeLink);
    // get the current path of the page and split it into segments
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/").filter((segment)=>segment !== "");
    // variables to keep track of the path and previous segment
    let path = "/";
    let previousSegment = "";
    // iterate through the path segments
    for(let i = 0; i < pathSegments.length; i++){
        // append the current segment to the path
        path += pathSegments[i];
        // Check if the current segment is different from the previous segment
        if (pathSegments[i] !== "index.html" && pathSegments[i] !== previousSegment) {
            // create the segment link and add it to the breadcrumb list
            const segmentLink = $2a0a9d2c002157bd$var$createBreadcrumbLink(pathSegments[i], path);
            breadcrumbList.appendChild(segmentLink);
            // check if it is not the last segment to add a slash
            if (i !== pathSegments.length - 1) {
                const slash = document.createElement("span");
                slash.classList.add("breadcrumb-slash");
                slash.textContent = "/";
                breadcrumbList.appendChild(slash);
            }
        }
        // Update the previous segment
        previousSegment = pathSegments[i];
    }
    // Check if a parameter is provided and add it to the breadcrumb list
    if (param !== "") {
        const paramLink = $2a0a9d2c002157bd$var$createBreadcrumbLink(param);
        breadcrumbList.appendChild(paramLink);
    }
    // Append the breadcrumb list to the breadcrumb navigation container
    breadcrumbNav.appendChild(breadcrumbList);
    // Insert the breadcrumb navigation container at the beginning of the main element
    mainEl.insertAdjacentElement("afterbegin", breadcrumbNav);
}
// Function to create a breadcrumb link
function $2a0a9d2c002157bd$var$createBreadcrumbLink(text, href = "") {
    // only for the results page so it would not redirect towards an empty page
    if (text === "results") {
        const searchTerm = localStorage.getItem("searchTerm"); // retrieve the search term from local storage
        const searchParam = encodeURIComponent(searchTerm); // encode the search term for URL
        href = `/results/index.html?search=${searchParam}`;
    }
    // create the link element
    const link = document.createElement("a");
    link.href = href;
    link.textContent = text;
    // Create the list item element and add the link to it
    const listItem = document.createElement("li");
    listItem.classList.add("breadcrumb-item");
    listItem.appendChild(link);
    if (text === "Home") {
        // Create and append the slash element after the home link
        const slash = document.createElement("span");
        slash.classList.add("breadcrumb-home");
        slash.textContent = "/";
        listItem.appendChild(slash);
    }
    return listItem;
}
function $2a0a9d2c002157bd$export$ecf541e09a511845(param) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const url = urlParams.get(param);
    return url;
}
async function $2a0a9d2c002157bd$export$7a171f172be0782e(url) {
    const response = await fetch(url);
    const data = await response.json();
    console.log(data);
    return data;
}
function $2a0a9d2c002157bd$export$73bcfb39fabe8205(movie, list) {
    const favList = $2a0a9d2c002157bd$export$d3720feff416e85b(list) || [];
    const index = favList.findIndex((item)=>item.Title === movie.Title);
    if (index === -1) {
        favList.push({
            ...movie,
            poster: movie.Poster,
            title: movie.Title
        });
        $2a0a9d2c002157bd$export$1f73f60bdb811cb1(list, favList);
    }
}
function $2a0a9d2c002157bd$export$b61b48db6d2fd5e7(movie) {
    const comment = document.querySelector("#comment").value;
    const username = document.querySelector("#username").value;
    const mTitle = document.querySelector("#mTitle").value;
    const inputDate = document.querySelector("#formDateSend");
    const notice = document.querySelector(".notice");
    let d = new Date();
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    let date = `${months[d.getMonth()]}, ${d.getDate()} ${d.getFullYear()}`;
    let reviewLst = $2a0a9d2c002157bd$export$d3720feff416e85b("reviews") || [];
    if (!username == "" || !comment == "") {
        reviewLst.push({
            comment: comment,
            name: username,
            movie: mTitle,
            date: inputDate.value = date
        });
        $2a0a9d2c002157bd$export$1f73f60bdb811cb1("reviews", reviewLst);
        if (movie.Title) notice.innerHTML = `<p>Your Review for ${movie.Title} was added</p>`;
        else notice.innerHTML = `<p>Your Review for ${movie} was added</p>`;
        setTimeout(function() {
            window.location.reload();
        }, 4000);
    } else {
        console.log("comment not addewd");
        notice.innerHTML = `<p>There was an error and the comment was not added</p>`;
    }
}
function $2a0a9d2c002157bd$export$a339b9dfcf153d0e(img, movie, src) {
    const favList = $2a0a9d2c002157bd$export$d3720feff416e85b("fav-list") || [];
    img.src = src;
    $2a0a9d2c002157bd$export$1f73f60bdb811cb1("toggle-icon", true);
}

function $2a0a9d2c002157bd$export$538bbf850262f928() {
    const scrollBtn = document.createElement("img");
    scrollBtn.src = (parcelRequire("jgoh3"));
    scrollBtn.setAttribute("id", "scroll-Btn");
    document.body.appendChild(scrollBtn);
    document.addEventListener("scroll", ()=>{
        scrollBtn.style.display = window.scrollY > 100 ? "block" : "none";
    });
    scrollBtn.addEventListener("click", ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

});
parcelRequire.register("jgoh3", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("5r4Wf"), import.meta.url).toString();

});


parcelRequire.register("aDd0M", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("hQlsk"), import.meta.url).toString();

});

parcelRequire.register("cHMpw", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("19NDT"), import.meta.url).toString();

});

parcelRequire.register("faAV6", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("bErbz"), import.meta.url).toString();

});

parcelRequire.register("h560Q", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("4WbAZ"), import.meta.url).toString();

});

parcelRequire.register("e5r2s", function(module, exports) {

module.exports = new URL("../" + (parcelRequire("27Lyk")).resolve("9bpf5"), import.meta.url).toString();

});

var $7a808e805768f360$exports = {};
"use strict";
var $fd71bcdaa1a35b05$exports = {};
"use strict";
var $f9b5d605f52d8009$exports = {};
var $f9b5d605f52d8009$var$x = String;
var $f9b5d605f52d8009$var$create = function() {
    return {
        isColorSupported: false,
        reset: $f9b5d605f52d8009$var$x,
        bold: $f9b5d605f52d8009$var$x,
        dim: $f9b5d605f52d8009$var$x,
        italic: $f9b5d605f52d8009$var$x,
        underline: $f9b5d605f52d8009$var$x,
        inverse: $f9b5d605f52d8009$var$x,
        hidden: $f9b5d605f52d8009$var$x,
        strikethrough: $f9b5d605f52d8009$var$x,
        black: $f9b5d605f52d8009$var$x,
        red: $f9b5d605f52d8009$var$x,
        green: $f9b5d605f52d8009$var$x,
        yellow: $f9b5d605f52d8009$var$x,
        blue: $f9b5d605f52d8009$var$x,
        magenta: $f9b5d605f52d8009$var$x,
        cyan: $f9b5d605f52d8009$var$x,
        white: $f9b5d605f52d8009$var$x,
        gray: $f9b5d605f52d8009$var$x,
        bgBlack: $f9b5d605f52d8009$var$x,
        bgRed: $f9b5d605f52d8009$var$x,
        bgGreen: $f9b5d605f52d8009$var$x,
        bgYellow: $f9b5d605f52d8009$var$x,
        bgBlue: $f9b5d605f52d8009$var$x,
        bgMagenta: $f9b5d605f52d8009$var$x,
        bgCyan: $f9b5d605f52d8009$var$x,
        bgWhite: $f9b5d605f52d8009$var$x
    };
};
$f9b5d605f52d8009$exports = $f9b5d605f52d8009$var$create();
$f9b5d605f52d8009$exports.createColors = $f9b5d605f52d8009$var$create;



var $kjyEk = parcelRequire("kjyEk");
class $fd71bcdaa1a35b05$var$CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin) this.plugin = plugin;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, $fd71bcdaa1a35b05$var$CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = $f9b5d605f52d8009$exports.isColorSupported;
        if ($kjyEk) {
            if (color) css = $kjyEk(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $f9b5d605f52d8009$exports.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else mark = aside = (str)=>str;
        return lines.slice(start, end).map((line, index)=>{
            let number = start + 1 + index;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    }
}
$fd71bcdaa1a35b05$exports = $fd71bcdaa1a35b05$var$CssSyntaxError;
$fd71bcdaa1a35b05$var$CssSyntaxError.default = $fd71bcdaa1a35b05$var$CssSyntaxError;


var $ba9841313f34e122$exports = {};
"use strict";
var $3e62a7c46a076c9d$exports = {};
"use strict";
var $763bd9a0a4fb5ee7$export$ae5e7911ce0728f9;
var $763bd9a0a4fb5ee7$export$94fa0a6beb22f989;
"use strict";
$763bd9a0a4fb5ee7$export$ae5e7911ce0728f9 = Symbol("isClean");
$763bd9a0a4fb5ee7$export$94fa0a6beb22f989 = Symbol("my");


var $3e62a7c46a076c9d$require$isClean = $763bd9a0a4fb5ee7$export$ae5e7911ce0728f9;
var $3e62a7c46a076c9d$require$my = $763bd9a0a4fb5ee7$export$94fa0a6beb22f989;

var $bbccb5753b9764cb$exports = {};
"use strict";
const $bbccb5753b9764cb$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $bbccb5753b9764cb$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
class $bbccb5753b9764cb$var$Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node, semicolon) {
        let name = "@" + node.name;
        let params = node.params ? this.rawValue(node, "params") : "";
        if (typeof node.raws.afterName !== "undefined") name += node.raws.afterName;
        else if (params) name += " ";
        if (node.nodes) this.block(node, name + params);
        else {
            let end = (node.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node);
        }
    }
    beforeAfter(node, detect) {
        let value;
        if (node.type === "decl") value = this.raw(node, null, "beforeDecl");
        else if (node.type === "comment") value = this.raw(node, null, "beforeComment");
        else if (detect === "before") value = this.raw(node, null, "beforeRule");
        else value = this.raw(node, null, "beforeClose");
        let buf = node.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node, null, "indent");
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node, start) {
        let between = this.raw(node, "between", "beforeOpen");
        this.builder(start + between + "{", node, "start");
        let after;
        if (node.nodes && node.nodes.length) {
            this.body(node);
            after = this.raw(node, "after");
        } else after = this.raw(node, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node, "end");
    }
    body(node) {
        let last = node.nodes.length - 1;
        while(last > 0){
            if (node.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node, "semicolon");
        for(let i = 0; i < node.nodes.length; i++){
            let child = node.nodes[i];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    comment(node) {
        let left = this.raw(node, "left", "commentLeft");
        let right = this.raw(node, "right", "commentRight");
        this.builder("/*" + left + node.text + right + "*/", node);
    }
    decl(node, semicolon) {
        let between = this.raw(node, "between", "colon");
        let string = node.prop + between + this.rawValue(node, "value");
        if (node.important) string += node.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node);
    }
    document(node) {
        this.body(node);
    }
    raw(node, own, detect) {
        let value;
        if (!detect) detect = own;
        // Already had
        if (own) {
            value = node.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node.parent;
        if (detect === "before") {
            // Hack for first rule in CSS
            if (!parent || parent.type === "root" && parent.first === node) return "";
            // `root` nodes in `document` should use only their own raws
            if (parent && parent.type === "document") return "";
        }
        // Floating child without parent
        if (!parent) return $bbccb5753b9764cb$var$DEFAULT_RAW[detect];
        // Detect style by other nodes
        let root = node.root();
        if (!root.rawCache) root.rawCache = {};
        if (typeof root.rawCache[detect] !== "undefined") return root.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node, detect);
        else {
            let method = "raw" + $bbccb5753b9764cb$var$capitalize(detect);
            if (this[method]) value = this[method](root, node);
            else root.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $bbccb5753b9764cb$var$DEFAULT_RAW[detect];
        root.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== "undefined") {
                    value = i.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root, node) {
        let value;
        root.walkComments((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeDecl(root, node) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeOpen(root) {
        let value;
        root.walk((i)=>{
            if (i.type !== "decl") {
                value = i.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && (i.parent !== root || root.first !== i)) {
                if (typeof i.raws.before !== "undefined") {
                    value = i.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.between !== "undefined") {
                value = i.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root) {
        if (root.raws.indent) return root.raws.indent;
        let value;
        root.walk((i)=>{
            let p = i.parent;
            if (p && p !== root && p.parent && p.parent === root) {
                if (typeof i.raws.before !== "undefined") {
                    let parts = i.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === "decl") {
                value = i.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node) {
        this.body(node);
        if (node.raws.after) this.builder(node.raws.after);
    }
    rule(node) {
        this.block(node, this.rawValue(node, "selector"));
        if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, "end");
    }
    stringify(node, semicolon) {
        /* c8 ignore start */ if (!this[node.type]) throw new Error("Unknown AST node type " + node.type + ". " + "Maybe you need to change PostCSS stringifier.");
        /* c8 ignore stop */ this[node.type](node, semicolon);
    }
}
$bbccb5753b9764cb$exports = $bbccb5753b9764cb$var$Stringifier;
$bbccb5753b9764cb$var$Stringifier.default = $bbccb5753b9764cb$var$Stringifier;


var $925d6d7facb3cb65$exports = {};
"use strict";

function $925d6d7facb3cb65$var$stringify(node, builder) {
    let str = new $bbccb5753b9764cb$exports(builder);
    str.stringify(node);
}
$925d6d7facb3cb65$exports = $925d6d7facb3cb65$var$stringify;
$925d6d7facb3cb65$var$stringify.default = $925d6d7facb3cb65$var$stringify;


function $3e62a7c46a076c9d$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === "proxyCache") continue;
        let value = obj[i];
        let type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (i === "source") cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map((j)=>$3e62a7c46a076c9d$var$cloneNode(j, cloned));
        else {
            if (type === "object" && value !== null) value = $3e62a7c46a076c9d$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
class $3e62a7c46a076c9d$var$Node {
    constructor(defaults = {}){
        this.raws = {};
        this[$3e62a7c46a076c9d$require$isClean] = false;
        this[$3e62a7c46a076c9d$require$my] = true;
        for(let name in defaults)if (name === "nodes") {
            this.nodes = [];
            for (let node of defaults[name])if (typeof node.clone === "function") this.append(node.clone());
            else this.append(node);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $3e62a7c46a076c9d$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $fd71bcdaa1a35b05$exports(message);
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (prop === "root") return ()=>node.root().toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node.markDirty();
                return true;
            }
        };
    }
    markDirty() {
        if (this[$3e62a7c46a076c9d$require$isClean]) {
            this[$3e62a7c46a076c9d$require$isClean] = false;
            let next = this;
            while(next = next.parent)next[$3e62a7c46a076c9d$require$isClean] = false;
        }
    }
    next() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) pos = this.positionInside(index, stringRepresentation);
        }
        return pos;
    }
    positionInside(index, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i = 0; i < index; i++)if (string[i] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
    }
    get proxyOf() {
        return this;
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) {
                start = this.positionInside(index, stringRepresentation);
                end = this.positionInside(index + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (opts.endIndex) end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $bbccb5753b9764cb$exports();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node of nodes){
                if (node === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node);
                    bookmark = node;
                } else this.parent.insertBefore(bookmark, node);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result = this;
        while(result.parent && result.parent.type !== "document")result = result.parent;
        return result;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i)=>{
                if (typeof i === "object" && i.toJSON) return i.toJSON(null, inputs);
                else return i;
            });
            else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input)=>input.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier = $925d6d7facb3cb65$exports) {
        if (stringifier.stringify) stringifier = stringifier.stringify;
        let result = "";
        stringifier(this, (i)=>{
            result += i;
        });
        return result;
    }
    warn(result, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result.warn(text, data);
    }
}
$3e62a7c46a076c9d$exports = $3e62a7c46a076c9d$var$Node;
$3e62a7c46a076c9d$var$Node.default = $3e62a7c46a076c9d$var$Node;


class $ba9841313f34e122$var$Declaration extends $3e62a7c46a076c9d$exports {
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = "decl";
    }
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
}
$ba9841313f34e122$exports = $ba9841313f34e122$var$Declaration;
$ba9841313f34e122$var$Declaration.default = $ba9841313f34e122$var$Declaration;


var $8a40f4a2119ab8f2$exports = {};
"use strict";

var $8a40f4a2119ab8f2$require$isClean = $763bd9a0a4fb5ee7$export$ae5e7911ce0728f9;
var $8a40f4a2119ab8f2$require$my = $763bd9a0a4fb5ee7$export$94fa0a6beb22f989;
var $6a67768850890379$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $6a67768850890379$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $kjyEk = parcelRequire("kjyEk");
var $6a67768850890379$require$SourceMapConsumer = $kjyEk.SourceMapConsumer;
var $6a67768850890379$require$SourceMapGenerator = $kjyEk.SourceMapGenerator;

var $kjyEk = parcelRequire("kjyEk");
var $6a67768850890379$require$dirname = $kjyEk.dirname;
var $6a67768850890379$require$relative = $kjyEk.relative;
var $6a67768850890379$require$resolve = $kjyEk.resolve;
var $6a67768850890379$require$sep = $kjyEk.sep;

var $kjyEk = parcelRequire("kjyEk");
var $6a67768850890379$require$pathToFileURL = $kjyEk.pathToFileURL;
var $3226d30fa7b80476$exports = {};
"use strict";

var $kjyEk = parcelRequire("kjyEk");
var $3226d30fa7b80476$require$SourceMapConsumer = $kjyEk.SourceMapConsumer;
var $3226d30fa7b80476$require$SourceMapGenerator = $kjyEk.SourceMapGenerator;

var $kjyEk = parcelRequire("kjyEk");
var $3226d30fa7b80476$require$fileURLToPath = $kjyEk.fileURLToPath;
var $3226d30fa7b80476$require$pathToFileURL = $kjyEk.pathToFileURL;

var $kjyEk = parcelRequire("kjyEk");
var $3226d30fa7b80476$require$isAbsolute = $kjyEk.isAbsolute;
var $3226d30fa7b80476$require$resolve = $kjyEk.resolve;
let $3753227fdc8a3f3b$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $3753227fdc8a3f3b$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3753227fdc8a3f3b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $3753227fdc8a3f3b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $3226d30fa7b80476$require$nanoid = $3753227fdc8a3f3b$export$ac4959f4f1338dfc;

var $kjyEk = parcelRequire("kjyEk");

var $c7c6b8ac5988220d$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c7c6b8ac5988220d$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $kjyEk = parcelRequire("kjyEk");
var $c7c6b8ac5988220d$require$SourceMapConsumer = $kjyEk.SourceMapConsumer;
var $c7c6b8ac5988220d$require$SourceMapGenerator = $kjyEk.SourceMapGenerator;

var $kjyEk = parcelRequire("kjyEk");
var $c7c6b8ac5988220d$require$existsSync = $kjyEk.existsSync;
var $c7c6b8ac5988220d$require$readFileSync = $kjyEk.readFileSync;

var $kjyEk = parcelRequire("kjyEk");
var $c7c6b8ac5988220d$require$dirname = $kjyEk.dirname;
var $c7c6b8ac5988220d$require$join = $kjyEk.join;
function $c7c6b8ac5988220d$var$fromBase64(str) {
    if ($c7c6b8ac5988220d$require$Buffer) return $c7c6b8ac5988220d$require$Buffer.from(str, "base64").toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
class $c7c6b8ac5988220d$var$PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : undefined;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $c7c6b8ac5988220d$require$dirname(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $c7c6b8ac5988220d$require$SourceMapConsumer(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $c7c6b8ac5988220d$var$fromBase64(text.substr(RegExp.lastMatch.length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        // sourceMappingURLs from comments, strings, etc.
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $c7c6b8ac5988220d$require$dirname(path);
        if ($c7c6b8ac5988220d$require$existsSync(path)) {
            this.mapFile = path;
            return $c7c6b8ac5988220d$require$readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $c7c6b8ac5988220d$require$SourceMapConsumer) return $c7c6b8ac5988220d$require$SourceMapGenerator.fromSourceMap(prev).toString();
            else if (prev instanceof $c7c6b8ac5988220d$require$SourceMapGenerator) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $c7c6b8ac5988220d$require$join($c7c6b8ac5988220d$require$dirname(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
}
$c7c6b8ac5988220d$exports = $c7c6b8ac5988220d$var$PreviousMap;
$c7c6b8ac5988220d$var$PreviousMap.default = $c7c6b8ac5988220d$var$PreviousMap;


let $3226d30fa7b80476$var$fromOffsetCache = Symbol("fromOffsetCache");
let $3226d30fa7b80476$var$sourceMapAvailable = Boolean($3226d30fa7b80476$require$SourceMapConsumer && $3226d30fa7b80476$require$SourceMapGenerator);
let $3226d30fa7b80476$var$pathAvailable = Boolean($3226d30fa7b80476$require$resolve && $3226d30fa7b80476$require$isAbsolute);
class $3226d30fa7b80476$var$Input {
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$3226d30fa7b80476$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $3226d30fa7b80476$require$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $3226d30fa7b80476$require$resolve(opts.from);
        }
        if ($3226d30fa7b80476$var$pathAvailable && $3226d30fa7b80476$var$sourceMapAvailable) {
            let map = new $c7c6b8ac5988220d$exports(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $3226d30fa7b80476$require$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let result, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result = new $fd71bcdaa1a35b05$exports(message, origin.endLine === undefined ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === undefined ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result = new $fd71bcdaa1a35b05$exports(message, endLine === undefined ? line : {
            column: column,
            line: line
        }, endLine === undefined ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($3226d30fa7b80476$require$pathToFileURL) result.input.url = $3226d30fa7b80476$require$pathToFileURL(this.file).toString();
            result.input.file = this.file;
        }
        return result;
    }
    get from() {
        return this.file || this.id;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$3226d30fa7b80476$var$fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[$3226d30fa7b80476$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$3226d30fa7b80476$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $3226d30fa7b80476$require$resolve(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($3226d30fa7b80476$require$isAbsolute(from.source)) fromUrl = $3226d30fa7b80476$require$pathToFileURL(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $3226d30fa7b80476$require$pathToFileURL(this.map.mapFile));
        let result = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($3226d30fa7b80476$require$fileURLToPath) result.file = $3226d30fa7b80476$require$fileURLToPath(fromUrl);
            else /* c8 ignore next 2 */ throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result.source = source;
        return result;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = undefined;
        }
        return json;
    }
}
$3226d30fa7b80476$exports = $3226d30fa7b80476$var$Input;
$3226d30fa7b80476$var$Input.default = $3226d30fa7b80476$var$Input;
if ($kjyEk && $kjyEk.registerInput) $kjyEk.registerInput($3226d30fa7b80476$var$Input);


let $6a67768850890379$var$sourceMapAvailable = Boolean($6a67768850890379$require$SourceMapConsumer && $6a67768850890379$require$SourceMapGenerator);
let $6a67768850890379$var$pathAvailable = Boolean($6a67768850890379$require$dirname && $6a67768850890379$require$resolve && $6a67768850890379$require$relative && $6a67768850890379$require$sep);
class $6a67768850890379$var$MapGenerator {
    constructor(stringify, root, opts, cssString){
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root = prev.root || $6a67768850890379$require$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $6a67768850890379$require$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = map.sourcesContent.map(()=>null);
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node = this.root.nodes[i];
                if (node.type !== "comment") continue;
                if (node.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i);
            }
        } else if (this.css) this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, "");
    }
    generate() {
        this.clearAnnotation();
        if ($6a67768850890379$var$pathAvailable && $6a67768850890379$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result = "";
            this.stringify(this.root, (i)=>{
                result += i;
            });
            return [
                result
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $6a67768850890379$require$SourceMapGenerator.fromSourceMap(prev);
        } else {
            this.map = new $6a67768850890379$require$SourceMapGenerator({
                file: this.outputFile()
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = "";
        this.map = new $6a67768850890379$require$SourceMapGenerator({
            file: this.outputFile()
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node, type)=>{
            this.css += str;
            if (node && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node.source && node.source.start) {
                    mapping.source = this.sourcePath(node);
                    mapping.original.line = node.source.start.line;
                    mapping.original.column = node.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node && type !== "start") {
                let p = node.parent || {
                    raws: {}
                };
                let childless = node.type === "decl" || node.type === "atrule" && !node.nodes;
                if (!childless || node !== p.last || p.raws.semicolon) {
                    if (node.source && node.source.end) {
                        mapping.source = this.sourcePath(node);
                        mapping.original.line = node.source.end.line;
                        mapping.original.column = node.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    }
    path(file) {
        if (file.indexOf("<") === 0) return file;
        if (/^\w+:\/\//.test(file)) return file;
        if (this.mapOpts.absolute) return file;
        let from = this.opts.to ? $6a67768850890379$require$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $6a67768850890379$require$dirname($6a67768850890379$require$resolve(from, this.mapOpts.annotation));
        file = $6a67768850890379$require$relative(from, file);
        return file;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node)=>{
                if (node.source && node.source.input.map) {
                    let map = node.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input = new $3226d30fa7b80476$exports(this.css, this.opts);
                if (input.map) this.previousMaps.push(input.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node)=>{
            if (node.source) {
                let from = node.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
        else return this.toUrl(this.path(node.source.input.from));
    }
    toBase64(str) {
        if ($6a67768850890379$require$Buffer) return $6a67768850890379$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        if ($6a67768850890379$require$pathToFileURL) return $6a67768850890379$require$pathToFileURL(path).toString();
        else throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
    toUrl(path) {
        if ($6a67768850890379$require$sep === "\\") path = path.replace(/\\/g, "/");
        return encodeURI(path).replace(/[#?]/g, encodeURIComponent);
    }
}
$6a67768850890379$exports = $6a67768850890379$var$MapGenerator;



var $ec3e6ba3c947f753$exports = {};
"use strict";

var $ec3e6ba3c947f753$require$isClean = $763bd9a0a4fb5ee7$export$ae5e7911ce0728f9;
var $ec3e6ba3c947f753$require$my = $763bd9a0a4fb5ee7$export$94fa0a6beb22f989;

var $d8a96e81fb4e1683$exports = {};
"use strict";

class $d8a96e81fb4e1683$var$Comment extends $3e62a7c46a076c9d$exports {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
}
$d8a96e81fb4e1683$exports = $d8a96e81fb4e1683$var$Comment;
$d8a96e81fb4e1683$var$Comment.default = $d8a96e81fb4e1683$var$Comment;



let $ec3e6ba3c947f753$var$parse, $ec3e6ba3c947f753$var$Rule, $ec3e6ba3c947f753$var$AtRule, $ec3e6ba3c947f753$var$Root;
function $ec3e6ba3c947f753$var$cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = $ec3e6ba3c947f753$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $ec3e6ba3c947f753$var$markDirtyUp(node) {
    node[$ec3e6ba3c947f753$require$isClean] = false;
    if (node.proxyOf.nodes) for (let i of node.proxyOf.nodes)$ec3e6ba3c947f753$var$markDirtyUp(i);
}
class $ec3e6ba3c947f753$var$Container extends $3e62a7c46a076c9d$exports {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node of nodes)this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node of this.nodes)node.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return undefined;
        let iterator = this.getIterator();
        let index, result;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index = this.indexes[iterator];
            result = callback(this.proxyOf.nodes[index], index);
            if (result === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    get first() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[0];
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (!node[prop]) return node[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return (...args)=>{
                    return node[prop](...args.map((i)=>{
                        if (typeof i === "function") return (child, index)=>i(child.toProxy(), index);
                        else return i;
                    }));
                };
                else if (prop === "every" || prop === "some") return (cb)=>{
                    return node[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === "root") return ()=>node.root().toProxy();
                else if (prop === "nodes") return node.nodes.map((i)=>i.toProxy());
                else if (prop === "first" || prop === "last") return node[prop].toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex < index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex <= index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    get last() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") nodes = $ec3e6ba3c947f753$var$cleanSource($ec3e6ba3c947f753$var$parse(nodes).nodes);
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $ba9841313f34e122$exports(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $ec3e6ba3c947f753$var$Rule(nodes)
        ];
        else if (nodes.name) nodes = [
            new $ec3e6ba3c947f753$var$AtRule(nodes)
        ];
        else if (nodes.text) nodes = [
            new $d8a96e81fb4e1683$exports(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        let processed = nodes.map((i)=>{
            /* c8 ignore next */ if (!i[$ec3e6ba3c947f753$require$my]) $ec3e6ba3c947f753$var$Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$ec3e6ba3c947f753$require$isClean]) $ec3e6ba3c947f753$var$markDirtyUp(i);
            if (typeof i.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node of nodes)this.proxyOf.nodes.unshift(node);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node of this.proxyOf.nodes)node.parent = undefined;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = undefined;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result;
            try {
                result = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result !== false && child.walk) result = child.walk(callback);
            return result;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === "atrule") return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "atrule" && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === "comment") return callback(child, i);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === "decl") return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "decl" && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === "rule") return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "rule" && child.selector === selector) return callback(child, i);
        });
    }
}
$ec3e6ba3c947f753$var$Container.registerParse = (dependant)=>{
    $ec3e6ba3c947f753$var$parse = dependant;
};
$ec3e6ba3c947f753$var$Container.registerRule = (dependant)=>{
    $ec3e6ba3c947f753$var$Rule = dependant;
};
$ec3e6ba3c947f753$var$Container.registerAtRule = (dependant)=>{
    $ec3e6ba3c947f753$var$AtRule = dependant;
};
$ec3e6ba3c947f753$var$Container.registerRoot = (dependant)=>{
    $ec3e6ba3c947f753$var$Root = dependant;
};
$ec3e6ba3c947f753$exports = $ec3e6ba3c947f753$var$Container;
$ec3e6ba3c947f753$var$Container.default = $ec3e6ba3c947f753$var$Container;
/* c8 ignore start */ $ec3e6ba3c947f753$var$Container.rebuild = (node)=>{
    if (node.type === "atrule") Object.setPrototypeOf(node, $ec3e6ba3c947f753$var$AtRule.prototype);
    else if (node.type === "rule") Object.setPrototypeOf(node, $ec3e6ba3c947f753$var$Rule.prototype);
    else if (node.type === "decl") Object.setPrototypeOf(node, $ba9841313f34e122$exports.prototype);
    else if (node.type === "comment") Object.setPrototypeOf(node, $d8a96e81fb4e1683$exports.prototype);
    else if (node.type === "root") Object.setPrototypeOf(node, $ec3e6ba3c947f753$var$Root.prototype);
    node[$ec3e6ba3c947f753$require$my] = true;
    if (node.nodes) node.nodes.forEach((child)=>{
        $ec3e6ba3c947f753$var$Container.rebuild(child);
    });
} /* c8 ignore stop */ ;


var $b1e7b9ccdcfdc3cc$exports = {};
"use strict";

let $b1e7b9ccdcfdc3cc$var$LazyResult, $b1e7b9ccdcfdc3cc$var$Processor;
class $b1e7b9ccdcfdc3cc$var$Document extends $ec3e6ba3c947f753$exports {
    constructor(defaults){
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        super({
            type: "document",
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $b1e7b9ccdcfdc3cc$var$LazyResult(new $b1e7b9ccdcfdc3cc$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$b1e7b9ccdcfdc3cc$var$Document.registerLazyResult = (dependant)=>{
    $b1e7b9ccdcfdc3cc$var$LazyResult = dependant;
};
$b1e7b9ccdcfdc3cc$var$Document.registerProcessor = (dependant)=>{
    $b1e7b9ccdcfdc3cc$var$Processor = dependant;
};
$b1e7b9ccdcfdc3cc$exports = $b1e7b9ccdcfdc3cc$var$Document;
$b1e7b9ccdcfdc3cc$var$Document.default = $b1e7b9ccdcfdc3cc$var$Document;


var $e8bfe6fe946eb8a1$exports = {};
/* eslint-disable no-console */ "use strict";
let $e8bfe6fe946eb8a1$var$printed = {};
$e8bfe6fe946eb8a1$exports = function warnOnce(message) {
    if ($e8bfe6fe946eb8a1$var$printed[message]) return;
    $e8bfe6fe946eb8a1$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};


var $621e2c1e489080d5$exports = {};
"use strict";
var $57d9831eed7a7e90$exports = {};
"use strict";
class $57d9831eed7a7e90$var$Warning {
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    }
}
$57d9831eed7a7e90$exports = $57d9831eed7a7e90$var$Warning;
$57d9831eed7a7e90$var$Warning.default = $57d9831eed7a7e90$var$Warning;


class $621e2c1e489080d5$var$Result {
    constructor(processor, root, opts){
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = undefined;
        this.map = undefined;
    }
    get content() {
        return this.css;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning = new $57d9831eed7a7e90$exports(text, opts);
        this.messages.push(warning);
        return warning;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === "warning");
    }
}
$621e2c1e489080d5$exports = $621e2c1e489080d5$var$Result;
$621e2c1e489080d5$var$Result.default = $621e2c1e489080d5$var$Result;


var $c69f3f459d97c2a6$exports = {};
"use strict";

var $d6ece5395d662d1b$exports = {};
"use strict";

var $355991b60a97b476$exports = {};
"use strict";
const $355991b60a97b476$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $355991b60a97b476$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $355991b60a97b476$var$BACKSLASH = "\\".charCodeAt(0);
const $355991b60a97b476$var$SLASH = "/".charCodeAt(0);
const $355991b60a97b476$var$NEWLINE = "\n".charCodeAt(0);
const $355991b60a97b476$var$SPACE = " ".charCodeAt(0);
const $355991b60a97b476$var$FEED = "\f".charCodeAt(0);
const $355991b60a97b476$var$TAB = "	".charCodeAt(0);
const $355991b60a97b476$var$CR = "\r".charCodeAt(0);
const $355991b60a97b476$var$OPEN_SQUARE = "[".charCodeAt(0);
const $355991b60a97b476$var$CLOSE_SQUARE = "]".charCodeAt(0);
const $355991b60a97b476$var$OPEN_PARENTHESES = "(".charCodeAt(0);
const $355991b60a97b476$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
const $355991b60a97b476$var$OPEN_CURLY = "{".charCodeAt(0);
const $355991b60a97b476$var$CLOSE_CURLY = "}".charCodeAt(0);
const $355991b60a97b476$var$SEMICOLON = ";".charCodeAt(0);
const $355991b60a97b476$var$ASTERISK = "*".charCodeAt(0);
const $355991b60a97b476$var$COLON = ":".charCodeAt(0);
const $355991b60a97b476$var$AT = "@".charCodeAt(0);
const $355991b60a97b476$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $355991b60a97b476$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $355991b60a97b476$var$RE_BAD_BRACKET = /.[\n"'(/\\]/;
const $355991b60a97b476$var$RE_HEX_ESCAPE = /[\da-f]/i;
$355991b60a97b476$exports = function tokenizer(input, options = {}) {
    let css = input.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $355991b60a97b476$var$NEWLINE:
            case $355991b60a97b476$var$SPACE:
            case $355991b60a97b476$var$TAB:
            case $355991b60a97b476$var$CR:
            case $355991b60a97b476$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $355991b60a97b476$var$SPACE || code === $355991b60a97b476$var$NEWLINE || code === $355991b60a97b476$var$TAB || code === $355991b60a97b476$var$CR || code === $355991b60a97b476$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $355991b60a97b476$var$OPEN_SQUARE:
            case $355991b60a97b476$var$CLOSE_SQUARE:
            case $355991b60a97b476$var$OPEN_CURLY:
            case $355991b60a97b476$var$CLOSE_CURLY:
            case $355991b60a97b476$var$COLON:
            case $355991b60a97b476$var$SEMICOLON:
            case $355991b60a97b476$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $355991b60a97b476$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n = css.charCodeAt(pos + 1);
                if (prev === "url" && n !== $355991b60a97b476$var$SINGLE_QUOTE && n !== $355991b60a97b476$var$DOUBLE_QUOTE && n !== $355991b60a97b476$var$SPACE && n !== $355991b60a97b476$var$NEWLINE && n !== $355991b60a97b476$var$TAB && n !== $355991b60a97b476$var$FEED && n !== $355991b60a97b476$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $355991b60a97b476$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $355991b60a97b476$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $355991b60a97b476$var$SINGLE_QUOTE:
            case $355991b60a97b476$var$DOUBLE_QUOTE:
                quote = code === $355991b60a97b476$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $355991b60a97b476$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $355991b60a97b476$var$AT:
                $355991b60a97b476$var$RE_AT_END.lastIndex = pos + 1;
                $355991b60a97b476$var$RE_AT_END.test(css);
                if ($355991b60a97b476$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $355991b60a97b476$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $355991b60a97b476$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $355991b60a97b476$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $355991b60a97b476$var$SLASH && code !== $355991b60a97b476$var$SPACE && code !== $355991b60a97b476$var$NEWLINE && code !== $355991b60a97b476$var$TAB && code !== $355991b60a97b476$var$CR && code !== $355991b60a97b476$var$FEED) {
                    next += 1;
                    if ($355991b60a97b476$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($355991b60a97b476$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $355991b60a97b476$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $355991b60a97b476$var$SLASH && css.charCodeAt(pos + 1) === $355991b60a97b476$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $355991b60a97b476$var$RE_WORD_END.lastIndex = pos + 1;
                    $355991b60a97b476$var$RE_WORD_END.test(css);
                    if ($355991b60a97b476$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $355991b60a97b476$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};



var $563b64967a12cbc2$exports = {};
"use strict";

class $563b64967a12cbc2$var$AtRule extends $ec3e6ba3c947f753$exports {
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
}
$563b64967a12cbc2$exports = $563b64967a12cbc2$var$AtRule;
$563b64967a12cbc2$var$AtRule.default = $563b64967a12cbc2$var$AtRule;
$ec3e6ba3c947f753$exports.registerAtRule($563b64967a12cbc2$var$AtRule);


var $ea4e5e8196cbb851$exports = {};
"use strict";

let $ea4e5e8196cbb851$var$LazyResult, $ea4e5e8196cbb851$var$Processor;
class $ea4e5e8196cbb851$var$Root extends $ec3e6ba3c947f753$exports {
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node of nodes)node.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $ea4e5e8196cbb851$var$LazyResult(new $ea4e5e8196cbb851$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$ea4e5e8196cbb851$var$Root.registerLazyResult = (dependant)=>{
    $ea4e5e8196cbb851$var$LazyResult = dependant;
};
$ea4e5e8196cbb851$var$Root.registerProcessor = (dependant)=>{
    $ea4e5e8196cbb851$var$Processor = dependant;
};
$ea4e5e8196cbb851$exports = $ea4e5e8196cbb851$var$Root;
$ea4e5e8196cbb851$var$Root.default = $ea4e5e8196cbb851$var$Root;
$ec3e6ba3c947f753$exports.registerRoot($ea4e5e8196cbb851$var$Root);


var $cca49e6d08250472$exports = {};
"use strict";

var $10e4e97fa3c9470d$exports = {};
"use strict";
let $10e4e97fa3c9470d$var$list = {
    comma (string) {
        return $10e4e97fa3c9470d$var$list.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return $10e4e97fa3c9470d$var$list.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
$10e4e97fa3c9470d$exports = $10e4e97fa3c9470d$var$list;
$10e4e97fa3c9470d$var$list.default = $10e4e97fa3c9470d$var$list;


class $cca49e6d08250472$var$Rule extends $ec3e6ba3c947f753$exports {
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $10e4e97fa3c9470d$exports.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep);
    }
}
$cca49e6d08250472$exports = $cca49e6d08250472$var$Rule;
$cca49e6d08250472$var$Rule.default = $cca49e6d08250472$var$Rule;
$ec3e6ba3c947f753$exports.registerRule($cca49e6d08250472$var$Rule);


const $d6ece5395d662d1b$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $d6ece5395d662d1b$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
class $d6ece5395d662d1b$var$Parser {
    constructor(input){
        this.input = input;
        this.root = new $ea4e5e8196cbb851$exports();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.customProperty = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node = new $563b64967a12cbc2$exports();
        node.name = token[1].slice(1);
        if (node.name === "") this.unnamedAtrule(node, token);
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node.source.end = this.getPosition(token[2]);
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) node.source.end = this.getPosition(prev[3] || prev[2]);
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node, "params", params);
            if (last) {
                token = params[params.length - 1];
                node.source.end = this.getPosition(token[3] || token[2]);
                this.spaces = node.raws.between;
                node.raws.between = "";
            }
        } else {
            node.raws.afterName = "";
            node.params = "";
        }
        if (open) {
            node.nodes = [];
            this.current = node;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
        // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
        // And because we need it after that one we do +1 to get the next one.
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node = new $d8a96e81fb4e1683$exports();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node.text = "";
            node.raws.left = text;
            node.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node.text = match[2];
            node.raws.left = match[1];
            node.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $355991b60a97b476$exports(this.input);
    }
    decl(tokens, customProperty) {
        let node = new $ba9841313f34e122$exports();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node.source.end = this.getPosition(last[3] || last[2] || $d6ece5395d662d1b$var$findLastWithPosition(tokens));
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node.raws.before += tokens.shift()[1];
        }
        node.source.start = this.getPosition(tokens[0][2]);
        node.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node.prop += tokens.shift()[1];
        }
        node.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node.raws.between += token[1];
            }
        }
        if (node.prop[0] === "_" || node.prop[0] === "*") {
            node.raws.before += node.prop[0];
            node.prop = node.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === "!important") {
                node.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node.important = true;
                    node.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        let hasWord = tokens.some((i)=>i[0] !== "space" && i[0] !== "comment");
        if (hasWord) {
            node.raws.between += firstSpaces.map((i)=>i[1]).join("");
            firstSpaces = [];
        }
        this.raw(node, "value", firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node = new $cca49e6d08250472$exports();
        this.init(node, token[2]);
        node.selector = "";
        node.raws.between = "";
        this.current = node;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node, offset) {
        this.current.push(node);
        node.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node.raws.before = this.spaces;
        this.spaces = "";
        if (node.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {
    // Hook for Safe Parser
    }
    raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === "space" && i === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
                next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
                if (!$d6ece5395d662d1b$var$SAFE_COMMENT_NEIGHBOR[prev] && !$d6ece5395d662d1b$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], "");
            node.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node = new $cca49e6d08250472$exports();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, "selector", tokens);
        this.current = node;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result = "";
        for(let i = from; i < tokens.length; i++)result += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
}
$d6ece5395d662d1b$exports = $d6ece5395d662d1b$var$Parser;



function $c69f3f459d97c2a6$var$parse(css, opts) {
    let input = new $3226d30fa7b80476$exports(css, opts);
    let parser = new $d6ece5395d662d1b$exports(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
$c69f3f459d97c2a6$exports = $c69f3f459d97c2a6$var$parse;
$c69f3f459d97c2a6$var$parse.default = $c69f3f459d97c2a6$var$parse;
$ec3e6ba3c947f753$exports.registerParse($c69f3f459d97c2a6$var$parse);



const $8a40f4a2119ab8f2$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const $8a40f4a2119ab8f2$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $8a40f4a2119ab8f2$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $8a40f4a2119ab8f2$var$CHILDREN = 0;
function $8a40f4a2119ab8f2$var$isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $8a40f4a2119ab8f2$var$getEvents(node) {
    let key = false;
    let type = $8a40f4a2119ab8f2$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === "decl") key = node.prop.toLowerCase();
    else if (node.type === "atrule") key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + "-" + key,
        $8a40f4a2119ab8f2$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node.append) return [
        type,
        $8a40f4a2119ab8f2$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $8a40f4a2119ab8f2$var$toStack(node) {
    let events;
    if (node.type === "document") events = [
        "Document",
        $8a40f4a2119ab8f2$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node.type === "root") events = [
        "Root",
        $8a40f4a2119ab8f2$var$CHILDREN,
        "RootExit"
    ];
    else events = $8a40f4a2119ab8f2$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $8a40f4a2119ab8f2$var$cleanMarks(node) {
    node[$8a40f4a2119ab8f2$require$isClean] = false;
    if (node.nodes) node.nodes.forEach((i)=>$8a40f4a2119ab8f2$var$cleanMarks(i));
    return node;
}
let $8a40f4a2119ab8f2$var$postcss = {};
class $8a40f4a2119ab8f2$var$LazyResult {
    constructor(processor, css, opts){
        this.stringified = false;
        this.processed = false;
        let root;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root = $8a40f4a2119ab8f2$var$cleanMarks(css);
        else if (css instanceof $8a40f4a2119ab8f2$var$LazyResult || css instanceof $621e2c1e489080d5$exports) {
            root = $8a40f4a2119ab8f2$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser = $c69f3f459d97c2a6$exports;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$8a40f4a2119ab8f2$require$my]) /* c8 ignore next 2 */ $ec3e6ba3c947f753$exports.rebuild(root);
        }
        this.result = new $621e2c1e489080d5$exports(processor, root, opts);
        this.helpers = {
            ...$8a40f4a2119ab8f2$var$postcss,
            postcss: $8a40f4a2119ab8f2$var$postcss,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin)=>{
            if (typeof plugin === "object" && plugin.prepare) return {
                ...plugin,
                ...plugin.prepare(this.result)
            };
            else return plugin;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
            if (node) node.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin.postcssPlugin;
                error.setMessage();
            } else plugin.postcssVersion;
        } catch (err) {
            /* c8 ignore next 3 */ // eslint-disable-next-line no-console
            if (console && console.error) console.error(err);
        }
        return error;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin,
                cb
            ]);
        };
        for (let plugin of this.plugins){
            if (typeof plugin === "object") for(let event in plugin){
                if (!$8a40f4a2119ab8f2$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
                if (!$8a40f4a2119ab8f2$var$NOT_VISITORS[event]) {
                    if (typeof plugin[event] === "object") {
                        for(let filter in plugin[event])if (filter === "*") add(plugin, event, plugin[event][filter]);
                        else add(plugin, event + "-" + filter.toLowerCase(), plugin[event][filter]);
                    } else if (typeof plugin[event] === "function") add(plugin, event, plugin[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin = this.plugins[i];
            let promise = this.runOnRoot(plugin);
            if ($8a40f4a2119ab8f2$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$8a40f4a2119ab8f2$require$isClean]){
                root[$8a40f4a2119ab8f2$require$isClean] = true;
                let stack = [
                    $8a40f4a2119ab8f2$var$toStack(root)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($8a40f4a2119ab8f2$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node = stack[stack.length - 1].node;
                        throw this.handleError(e, node);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin;
                try {
                    if (root.type === "document") {
                        let roots = root.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
            if (typeof plugin === "object" && plugin.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root)=>plugin.Once(root, this.helpers));
                    if ($8a40f4a2119ab8f2$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin.Once(this.result.root, this.helpers);
            } else if (typeof plugin === "function") return plugin(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $925d6d7facb3cb65$exports;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $6a67768850890379$exports(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin of this.plugins){
            let promise = this.runOnRoot(plugin);
            if ($8a40f4a2119ab8f2$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$8a40f4a2119ab8f2$require$isClean]){
                root[$8a40f4a2119ab8f2$require$isClean] = true;
                this.walkSync(root);
            }
            if (this.listeners.OnceExit) {
                if (root.type === "document") for (let subRoot of root.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors){
            this.result.lastPlugin = plugin;
            let promise;
            try {
                promise = visitor(node, this.helpers);
            } catch (e) {
                throw this.handleError(e, node.proxyOf);
            }
            if (node.type !== "root" && node.type !== "document" && !node.parent) return true;
            if ($8a40f4a2119ab8f2$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node: node, visitors: visitors } = visit;
        if (node.type !== "root" && node.type !== "document" && !node.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
            let [plugin, visitor] = visitors[visit.visitorIndex];
            visit.visitorIndex += 1;
            if (visit.visitorIndex === visitors.length) {
                visit.visitors = [];
                visit.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin;
            try {
                return visitor(node.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node);
            }
        }
        if (visit.iterator !== 0) {
            let iterator = visit.iterator;
            let child;
            while(child = node.nodes[node.indexes[iterator]]){
                node.indexes[iterator] += 1;
                if (!child[$8a40f4a2119ab8f2$require$isClean]) {
                    child[$8a40f4a2119ab8f2$require$isClean] = true;
                    stack.push($8a40f4a2119ab8f2$var$toStack(child));
                    return;
                }
            }
            visit.iterator = 0;
            delete node.indexes[iterator];
        }
        let events = visit.events;
        while(visit.eventIndex < events.length){
            let event = events[visit.eventIndex];
            visit.eventIndex += 1;
            if (event === $8a40f4a2119ab8f2$var$CHILDREN) {
                if (node.nodes && node.nodes.length) {
                    node[$8a40f4a2119ab8f2$require$isClean] = true;
                    visit.iterator = node.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node) {
        node[$8a40f4a2119ab8f2$require$isClean] = true;
        let events = $8a40f4a2119ab8f2$var$getEvents(node);
        for (let event of events){
            if (event === $8a40f4a2119ab8f2$var$CHILDREN) {
                if (node.nodes) node.each((child)=>{
                    if (!child[$8a40f4a2119ab8f2$require$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
}
$8a40f4a2119ab8f2$var$LazyResult.registerPostcss = (dependant)=>{
    $8a40f4a2119ab8f2$var$postcss = dependant;
};
$8a40f4a2119ab8f2$exports = $8a40f4a2119ab8f2$var$LazyResult;
$8a40f4a2119ab8f2$var$LazyResult.default = $8a40f4a2119ab8f2$var$LazyResult;
$ea4e5e8196cbb851$exports.registerLazyResult($8a40f4a2119ab8f2$var$LazyResult);
$b1e7b9ccdcfdc3cc$exports.registerLazyResult($8a40f4a2119ab8f2$var$LazyResult);



var $44ec38660d9d72fd$exports = {};
"use strict";
var $2f27d19f43c9584e$exports = {};
"use strict";





class $2f27d19f43c9584e$var$NoWorkResult {
    constructor(processor, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        let root;
        let str = $925d6d7facb3cb65$exports;
        this.result = new $621e2c1e489080d5$exports(this._processor, root, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new $6a67768850890379$exports(str, root, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root;
        let parser = $c69f3f459d97c2a6$exports;
        try {
            root = parser(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root;
            return root;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
}
$2f27d19f43c9584e$exports = $2f27d19f43c9584e$var$NoWorkResult;
$2f27d19f43c9584e$var$NoWorkResult.default = $2f27d19f43c9584e$var$NoWorkResult;





class $44ec38660d9d72fd$var$Processor {
    constructor(plugins = []){
        this.version = "8.4.25";
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === "object" && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === "object" && i.postcssPlugin) normalized.push(i);
            else if (typeof i === "function") normalized.push(i);
            else if (typeof i === "object" && (i.parse || i.stringify)) ;
            else throw new Error(i + " is not a PostCSS plugin");
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (this.plugins.length === 0 && typeof opts.parser === "undefined" && typeof opts.stringifier === "undefined" && typeof opts.syntax === "undefined") return new $2f27d19f43c9584e$exports(this, css, opts);
        else return new $8a40f4a2119ab8f2$exports(this, css, opts);
    }
    use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin
        ]));
        return this;
    }
}
$44ec38660d9d72fd$exports = $44ec38660d9d72fd$var$Processor;
$44ec38660d9d72fd$var$Processor.default = $44ec38660d9d72fd$var$Processor;
$ea4e5e8196cbb851$exports.registerProcessor($44ec38660d9d72fd$var$Processor);
$b1e7b9ccdcfdc3cc$exports.registerProcessor($44ec38660d9d72fd$var$Processor);



var $fada791b0db7ac9e$exports = {};
"use strict";







function $fada791b0db7ac9e$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$fada791b0db7ac9e$var$fromJSON(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input of ownInputs){
            let inputHydrated = {
                ...input,
                __proto__: $3226d30fa7b80476$exports.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $c7c6b8ac5988220d$exports.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n)=>$fada791b0db7ac9e$var$fromJSON(n, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $ea4e5e8196cbb851$exports(defaults);
    else if (defaults.type === "decl") return new $ba9841313f34e122$exports(defaults);
    else if (defaults.type === "rule") return new $cca49e6d08250472$exports(defaults);
    else if (defaults.type === "comment") return new $d8a96e81fb4e1683$exports(defaults);
    else if (defaults.type === "atrule") return new $563b64967a12cbc2$exports(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
$fada791b0db7ac9e$exports = $fada791b0db7ac9e$var$fromJSON;
$fada791b0db7ac9e$var$fromJSON.default = $fada791b0db7ac9e$var$fromJSON;













function $7a808e805768f360$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $44ec38660d9d72fd$exports(plugins);
}
$7a808e805768f360$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\n" + "https://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $44ec38660d9d72fd$exports().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $7a808e805768f360$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$7a808e805768f360$var$postcss.stringify = $925d6d7facb3cb65$exports;
$7a808e805768f360$var$postcss.parse = $c69f3f459d97c2a6$exports;
$7a808e805768f360$var$postcss.fromJSON = $fada791b0db7ac9e$exports;
$7a808e805768f360$var$postcss.list = $10e4e97fa3c9470d$exports;
$7a808e805768f360$var$postcss.comment = (defaults)=>new $d8a96e81fb4e1683$exports(defaults);
$7a808e805768f360$var$postcss.atRule = (defaults)=>new $563b64967a12cbc2$exports(defaults);
$7a808e805768f360$var$postcss.decl = (defaults)=>new $ba9841313f34e122$exports(defaults);
$7a808e805768f360$var$postcss.rule = (defaults)=>new $cca49e6d08250472$exports(defaults);
$7a808e805768f360$var$postcss.root = (defaults)=>new $ea4e5e8196cbb851$exports(defaults);
$7a808e805768f360$var$postcss.document = (defaults)=>new $b1e7b9ccdcfdc3cc$exports(defaults);
$7a808e805768f360$var$postcss.CssSyntaxError = $fd71bcdaa1a35b05$exports;
$7a808e805768f360$var$postcss.Declaration = $ba9841313f34e122$exports;
$7a808e805768f360$var$postcss.Container = $ec3e6ba3c947f753$exports;
$7a808e805768f360$var$postcss.Processor = $44ec38660d9d72fd$exports;
$7a808e805768f360$var$postcss.Document = $b1e7b9ccdcfdc3cc$exports;
$7a808e805768f360$var$postcss.Comment = $d8a96e81fb4e1683$exports;
$7a808e805768f360$var$postcss.Warning = $57d9831eed7a7e90$exports;
$7a808e805768f360$var$postcss.AtRule = $563b64967a12cbc2$exports;
$7a808e805768f360$var$postcss.Result = $621e2c1e489080d5$exports;
$7a808e805768f360$var$postcss.Input = $3226d30fa7b80476$exports;
$7a808e805768f360$var$postcss.Rule = $cca49e6d08250472$exports;
$7a808e805768f360$var$postcss.Root = $ea4e5e8196cbb851$exports;
$7a808e805768f360$var$postcss.Node = $3e62a7c46a076c9d$exports;
$8a40f4a2119ab8f2$exports.registerPostcss($7a808e805768f360$var$postcss);
$7a808e805768f360$exports = $7a808e805768f360$var$postcss;
$7a808e805768f360$var$postcss.default = $7a808e805768f360$var$postcss;



var $75jjV = parcelRequire("75jjV");

var $eL13W = parcelRequire("eL13W");

async function $6bda78e1fd526e61$export$73bad228fa1d3492(movieTitle, selector) {
    let container = document.querySelector(selector);
    try {
        const commentDiv = document.querySelector("#movie-comments");
        let movie = await (await (0, $75jjV.getMoviesByTitle)(movieTitle)).json();
        if (!movie) {
            // if the movie is not available in omdb database, looks into tmdb
            movie = await (0, $75jjV.getMovies)(`search/movie?query=${encodeURIComponent(movieTitle)}`);
            if (!movie.results || movie.results.length === 0) throw new SyntaxError("The movie you are trying to find is not available.");
            movie = movie.results[0];
        }
        if (!movieTitle) {
            // Display a message when the movie title is null or undefined
            const errorMessage = `
        <div class="error-Mess">
          <h1>No movie found</h1>
          <p>Please select a valid movie.</p>
        </div>
      `;
            container.innerHTML = errorMessage;
            return;
        }
        let renderMD = $6bda78e1fd526e61$var$renderMovieDetails(movie);
        let comments = $6bda78e1fd526e61$var$renderCommentForm(movie);
        container.innerHTML = renderMD;
        commentDiv.innerHTML = comments;
        const detailsContainer = document.querySelector(".detailsContainer");
        detailsContainer.style.backgroundImage = `url("${movie.Poster}")`;
        detailsContainer.style.backgroundSize = "cover";
        detailsContainer.style.backgroundPosition = "center";
        // Button icons
        const favBtn = document.querySelector("#fav-Btn");
        favBtn.addEventListener("click", ()=>{
            (0, $eL13W.addMovieToStorage)(movie, "fav-list");
        });
        const watchlistBtn = document.querySelector("#watchlist-Btn");
        watchlistBtn.addEventListener("click", ()=>{
            (0, $eL13W.addMovieToStorage)(movie, "watch-list");
        });
        const watchPartyButton = document.querySelector(".joinBtn");
        // Redirects to the watch party page using the title of the movie
        watchPartyButton.addEventListener("click", ()=>{
            const movieTitle = encodeURIComponent(movie.Title);
            window.location.href = `/watch-party/index.html?movie=${movieTitle}`;
        });
        //ADD COMMENTS TO STORAGE
        const commentBtn = document.querySelector("#commtBtn");
        commentBtn.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $eL13W.addCommentToStorage)(movie);
        });
        //SHOW REVIEWS ON SCREEN
        const reviews = document.querySelector(".reviews");
        let commentList = (0, $eL13W.getLocalStorage)("reviews") || [];
        // console.log(commentList);
        if (commentList.length === 0) {
            // message to display when there is no user comments yet
            const noCommentsMessage = `<p>No comments yet</p>`;
            reviews.innerHTML = noCommentsMessage;
        }
        commentList.forEach((item)=>{
            if (movie.Title === item.movie) {
                let div = document.createElement("div");
                let name = document.createElement("h4");
                let comment = document.createElement("p");
                name.innerHTML = `💬 ${item.name} (${item.date})`;
                comment.innerHTML = item.comment;
                div.style.backgroundColor = "rgb(0, 0, 0, .5)";
                div.style.marginTop = ".5rem";
                div.style.padding = ".3rem 1rem";
                div.style.textAlign = "start";
                div.style.border = "2px solid #d0d0d0";
                div.appendChild(name);
                div.appendChild(comment);
                reviews.appendChild(div);
            }
        });
    } catch  {
        // to display when the movie's details are not available
        const gifImage = (parcelRequire("aDd0M"));
        const errorMessage = `
      <div class="error-Mess">
        <h1>The movie you are trying to find is not available yet</h1>
        <p>We are still working on it!</p>
        <img src="${gifImage}" alt="movie gif">
        <p>Return to the <a href="../index.html">Home Page</a> and explore more movies!</p>
      </div>
    `;
        container.innerHTML = errorMessage;
    }
}


function $6bda78e1fd526e61$var$renderMovieDetails(movie) {
    // console.log(movie);
    const favBtn = (parcelRequire("cHMpw"));
    const watchListBtn = (parcelRequire("faAV6"));
    let ratingsTemplate = "";
    if (movie.Ratings.length > 0) // checks how many rating are available
    for(let i = 0; i < movie.Ratings.length; i++)ratingsTemplate += `<p>🎬${movie.Ratings[i].Source}: ${movie.Ratings[i].Value}</p>`;
    else ratingsTemplate = "<p>Not enough ratings yet</p>";
    const template = `
    <div class="mov-inf">
      <h1>${movie.Title} (${movie.Year})</h1>
      <p><b>Genre:</b> ${movie.Genre}</p>
      <p><b>Runtime:</b> ${movie.Runtime}</p>
      <p><b>Released:</b> ${movie.Released}</p>
      <p><b>Country:</b> ${movie.Country}</p>
      <p><b>Rated:</b> ${movie.Rated}</p>
      <p><b>Director:</b> ${movie.Director}</p>
      <p><b>Actors:</b> ${movie.Actors}</p>
      <p><b>Language:</b> ${movie.Language}</p>
      <p><b>Awards:</b> ${movie.Awards}</p>
      <div class="btnContainer">
        <button id="fav-Btn" data-title="${movie.Title}"><img src="${favBtn}" alt="Fav Icon" title="Add ${movie.Title} to Favorites"></button>
        <button id="watchlist-Btn" data-title="${movie.Title}"><img src="${watchListBtn}" alt="Watchlist Icon" title="Add ${movie.Title} to Watch List"></button>
      </div>
      <div class="create-Party">
        <button class="joinBtn">Create Watch Party 🎥</button>
      </div>
    </div>
    <img class="mov-inf-img" src="${movie.Poster}" alt="Poster of ${movie.Title}">
    <div class="descr-wrapper">
      <div class="mov-inf-descr">
        <h2>Description</h2>
        <p>${movie.Plot}</p>
      </div>
      <div class="mov-inf-rating">
        <h2>⭐⭐Ratings⭐⭐<h2>
        ${ratingsTemplate}
      </div>
    </div>
  `;
    return template;
}
function $6bda78e1fd526e61$var$renderCommentForm(movie) {
    let form = `
    <h2>Reviews</h2>
    <div class="reviews"></div>

    <h2>Share a Comment</h2>
    <div class="notice"></div>
    <form method="post">
      <fieldset>
        <label>Name: <input id="username" type="text" name="name"></label>
        <label>Your Comment: <textarea id="comment" name="comment"></textarea></label>
        <input id="commtBtn" type="button" name="submit" value="Share Comment">
        <input id="mTitle" type="hidden" name="movieTitle" value="${movie.Title}">
        <input type="hidden" name="timeSend" id="formDateSend">
      </fieldset>
    </form>
  `;
    return form;
}



var $eL13W = parcelRequire("eL13W");
// creates the search box
function $ef9ead9c61ffd087$export$9eb1cf087813c7e() {
    const searchInput = document.createElement("input");
    searchInput.setAttribute("type", "text");
    searchInput.setAttribute("id", "searchInput");
    searchInput.setAttribute("placeholder", "Enter your search...");
    searchInput.classList.add("search-input");
    // create the search button element
    const searchButton = document.createElement("button");
    searchButton.setAttribute("id", "searchButton");
    searchButton.textContent = "\uD83D\uDD0D";
    searchButton.classList.add("search-button");
    const searchBox = document.createElement("div");
    searchBox.classList.add("search-box");
    searchBox.style.display = "inline-flex";
    searchBox.appendChild(searchInput);
    searchBox.appendChild(searchButton);
    // append the search box and button to the menu div
    const menuDiv = document.querySelector(".search-movie");
    menuDiv.prepend(searchBox);
}
function $ef9ead9c61ffd087$export$4b597114ade5582d(searchTerm) {
    localStorage.setItem("searchTerm", searchTerm);
    // Create URL parameters and set the search term
    const urlParams = new URLSearchParams();
    urlParams.set("search", searchTerm);
    // Get the root path of the website so we can uses the search box everywhere
    const rootPath = window.location.origin;
    // create the new URL with the search term as a parameter
    const newUrl = `${rootPath}/results/index.html?${urlParams.toString()}`;
    // redirect the page to the new URL
    window.location.href = newUrl;
}


function $2e0f731592f515ed$export$98a4d7f3a5ab0973() {
    const menu = document.querySelector(".menu");
    menu.innerHTML = $2e0f731592f515ed$var$renderNav();
    const priNav = document.querySelector("#primaryNav");
    const navEl = document.querySelector("nav");
    const x = document.querySelector("#hamburgerBtn");
    x.style.backgroundColor = "transparent";
    x.style.border = "none";
    x.style.cursor = "pointer";
    x.addEventListener("mouseover", ()=>{
        x.style.opacity = ".7";
        setTimeout(()=>{
            x.style.opacity = "1";
        }, 1000);
    });
    x.addEventListener("click", ()=>{
        priNav.classList.toggle("open");
        x.classList.toggle("open");
        navEl.classList.toggle("open");
    });
}


function $2e0f731592f515ed$var$renderNav() {
    return `<nav>
    <button id="hamburgerBtn">
        <span><img src="${(parcelRequire("h560Q"))}" alt="hamburger menu icon"></span>
        <span><img src="${(parcelRequire("e5r2s"))}" alt="close menu icon"></span>
    </button>
    <ul id="primaryNav">
        <li><a href="/user/index.html">Profile</a></li>
        <li><a href="/planning/index.html">Planner</a></li>
        <li><a href="/watch-party/index.html">Watch Party</a></li>
    </ul>
  </nav> `;
}


document.addEventListener("DOMContentLoaded", ()=>{
    const searchButton = document.querySelector("#searchButton");
    const searchInput = document.querySelector("#searchInput");
    //  event listener for when the research is sent
    searchButton.addEventListener("click", ()=>{
        const searchTerm = searchInput.value; // getting the value from the search input
        (0, $ef9ead9c61ffd087$export$4b597114ade5582d)(searchTerm); // redirecting to the search results page with the search term
    });
});
const $164cf12502b3ee95$var$movieTitle = (0, $eL13W.getParam)("movie");
// console.log(movieTitle);
(0, $eL13W.generateBreadcrumb)($164cf12502b3ee95$var$movieTitle);
(0, $6bda78e1fd526e61$export$73bad228fa1d3492)($164cf12502b3ee95$var$movieTitle, "#movie-detail");
(0, $ef9ead9c61ffd087$export$9eb1cf087813c7e)();
(0, $2e0f731592f515ed$export$98a4d7f3a5ab0973)();
(0, $eL13W.createScrollBtn)();


//# sourceMappingURL=index.68292845.js.map
